export const WINDOW_NAME = 'twainsport_iframe';

export const UPDATE_HEIGHT_REPEAT = 5;

export const MESSAGE_PREFIX = 'TwainSports loader:';
